import { render, staticRenderFns } from "./company-quote-plan-info-new.vue?vue&type=template&id=0b9ab934&scoped=true&"
import script from "./company-quote-plan-info-new.vue?vue&type=script&lang=js&"
export * from "./company-quote-plan-info-new.vue?vue&type=script&lang=js&"
import style0 from "./company-quote-plan-info-new.vue?vue&type=style&index=0&id=0b9ab934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ab934",
  null
  
)

export default component.exports